import { render, staticRenderFns } from "./LoginWithToken.vue?vue&type=template&id=33740eb8&"
import script from "./LoginWithToken.vue?vue&type=script&lang=js&"
export * from "./LoginWithToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports